
var site = window.site || {};

site.stickyATC = {
    nodes: {
        addToCartBtn: document.querySelector('.product__info-wrapper button[name="add"]'),
        stickyContainer: document.querySelector('.sticky-atc-section'),
        falseSelectBtn: document.querySelector('.false-select-cta'),
        falseAddBtn:  document.querySelector('.false-atc-button'),
        siteFooter: document.querySelector('footer')
    },
    observerConfig: { childList:true, subtree:true},
    // Observer to show/hide false Select A Size button when Swatch King disables the primary Add to Cart button
    swatchObserver: function(falseSelectBtn, falseAddBtn) {
        atcBtnObserver = new MutationObserver(function(mutations_list){
            mutations_list.forEach(function(mutation){
                mutation.addedNodes.forEach(function(addedNode){
                    if (addedNode.nodeName=='#text') {
                        if (addedNode.nodeValue=='Select a Size') {
                            falseSelectBtn?.classList.add('show');
                            falseAddBtn?.classList.remove('show');
                        }
                        else {
                            falseSelectBtn?.classList.remove('show');
                            falseAddBtn?.classList.add('show');
                        }
                    };
                }) 

            });
        });

        atcBtnObserver.observe(this.nodes.addToCartBtn, this.observerConfig);
    },
    //Function to show/hide sticky Add To Cart container 
    showStickyContainer: function() {
        const intOptions = {
            rootMargin: '0px',
            threshold: 0
        };

        const intCallback =  (entries)=>{
            entries.forEach((entry) => {
                if (!entry.isIntersecting && this.nodes.addToCartBtn?.getBoundingClientRect().bottom < 0) {
                    this.nodes.stickyContainer?.classList.add('show');
                }
                else {
                    this.nodes.stickyContainer?.classList.remove('show');
                }
            })
        }

        const footerObserver  = new IntersectionObserver(intCallback, intOptions);
        footerObserver.observe(this.nodes.siteFooter);
    },
    addBtnListener: function() {
        //Listener to click Primary Add to Cart Button when false Add to Cart is clicked
        this.nodes.falseAddBtn.addEventListener('click', (event)=> {
            this.nodes.addToCartBtn?.click();
        });
    },
    init: function() {
        this.swatchObserver(this.nodes.falseSelectBtn, this.nodes.falseAddBtn);
        this.showStickyContainer();
        this.addBtnListener();
        window.addEventListener('scroll', () => {
            this.showStickyContainer();
        });
    }
};

site.stickyATC.init();